// ============================================================
// esignFormat.ts — B4c: small pure formatters shared by the public verify
// page and Admin → E-signature (UK dates in UK time, grouped fingerprints).
// ============================================================

const valid = (iso: string | null | undefined): Date | null => {
  if (!iso) return null
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? null : d
}

// "14 October 2026"
export const ukDate = (iso: string | null | undefined): string => {
  const d = valid(iso)
  return d ? d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/London' }) : ''
}

// "14 October 2026 at 10:32" (UK time)
export const ukDateTime = (iso: string | null | undefined): string => {
  const d = valid(iso)
  if (!d) return ''
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/London' })
  return `${ukDate(iso)} at ${time}`
}

// A SHA-256 in readable groups of four ("3F2A 9C10 …") — wraps cleanly.
export const groupHex = (hex: string): string =>
  (hex.replace(/[^0-9a-f]/gi, '').toUpperCase().match(/.{1,4}/g) ?? []).join(' ')

// (batch 1b) Save a downloaded file (PDF / ZIP) with its name.
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url; a.download = filename
  document.body.appendChild(a); a.click(); a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 10_000)
}
